import Cookies from 'js-cookie';
import React from 'react';
import * as ReactRedux from 'react-redux';

import {toast} from 'react-toastify';
import {axios, venditshop} from '../../index';
import {
  receiveLoadingUpdate,
  setMSG,
  setUpdateAmount,
  setUpdateMSG,
  updateMesseCart,
  updateShoppingCart
} from '../../redux/actions';
import Body from '../structure/fakerum/Body';
import Footer from '../structure/fakerum/Footer';
import Header from '../structure/fakerum/Header';
import Modal from '../structure/fakerum/Modal';
import P1 from '../structure/helper/P1';
import P3 from '../structure/helper/P3';

const parseMengeToAnbruch = (menge) => {
  try {
    let [vk, basis] = parseFloat(menge).toFixed(2).toString().split('.');
    basis = basis.padEnd(2, '0');
    return {
      vk: parseInt(vk || 0, 10),
      basis: parseInt(basis || 0, 10)
    };
  } catch (e) {
    return {
      vk: 0,
      basis: 0
    };
  }
};

class ProductInput extends React.PureComponent {
  constructor (props) {
    super(props);
    let menge = props.menge || 0;
    if (menge < 0) {
      menge = 1;
    }

    this.vk_ref = React.createRef();

    this.anbruchmodal_ref = React.createRef();
    const anbruch = props.meta?.licenseCache?.anbruch && !!props.anbruch;
    const minMax = props.meta?.licenseCache?.minMaxMenge || false;
    const gebinde = props.meta?.licenseCache?.kommissionGebinde || false;
    let vk = 0;
    let basis = 0;
    if (anbruch && props.cart) {
      const res = parseMengeToAnbruch(menge);
      vk = res.vk || 0;
      basis = res.basis || 0;
    }
    //Wenn der Atrtikel noch nicht im Warenkorb ist, dann mit 0 darstellen
    if (anbruch && !props.cart) {
      vk = 0;
      basis = 0;
    }
    let mengen = props?.hausmessemengen || {};

    this.state = {
      menge: menge,
      changed: false,
      anbruchModal: false,
      menge_vk: vk,
      menge_basis: basis,
      showFavModal: false,
      favoriten_bez: '',
      favoriten_neumenge: 1,
      favoriten: props.favoriten,
      bestellartikelPopup: false,
      bestellartikelpopuptext: '',
      bestellartikelPopupButtonText: 'Hinzufügen',
      umkartonPopup: false,
      hausmesseMengen: mengen
    };

    this.handleKeyDownMenge = (e) => {
      console.log("handleKeyDownMenge");
      if (e.key === '.' || e.key === ',') {
        e.preventDefault();
      }
      if (e.key === 'Enter' && this.state.changed) {
        this.setState({changed: !this.props.changeCart(this.state.menge, minMax, gebinde, this?.props?.erlaubteDistMenge, (this.props?.meta?.conf?.cssCompletePath ? this.props?.meta?.hostname : ''))});
        e.target.blur();
        return;
      }
      if (e.key === 'Enter' && this.props?.mobile) {
        e.target.blur();
      }
    };

    this.removeFromCart = () => {
      this.setState({menge: 0});
      this.props.changeCart(0, null, null, null, (this.props?.meta?.conf?.cssCompletePath ? this.props?.meta?.hostname : ''));
    };

    this.showAnbruchModal = () => {
      this.setState({anbruchModal: true});
    };

    this.hideAnbruchModal = () => {
      document.body.style.overflowY = 'auto';
      this.setState({anbruchModal: false});
    };
    this.saveAnbruch = () => {
      const vk = this.state.menge_vk || 0;
      const basis = this.state.menge_basis || 0;
      const menge = `${vk}.${basis.toString().padStart(2, '0')}`;
      let changeCallback = () => this.props.changeCart(this.state.menge, minMax, gebinde, this?.props?.erlaubteDistMenge, (this.props?.meta?.conf?.cssCompletePath ? this.props?.meta?.hostname : ''));
      if (this.props.changeCallback && typeof this.props.changeCallback === 'function') {
        changeCallback = () => {
          this.props.changeCart(this.state.menge, minMax, gebinde, this?.props?.erlaubteDistMenge, (this.props?.meta?.conf?.cssCompletePath ? this.props?.meta?.hostname : ''));
          this.props.changeCallback(this.state.menge, this.props?.lfdnr);
        };
      }
      this.setState({
        menge,
        anbruchModal: false
      }, changeCallback);
    };

    this.showFavModal = async () => {
      if (!this.state.favoriten) {
        this?.props?.changeLoading(true);
        const p = await axios.post((this.props?.meta?.conf?.cssCompletePath ? this.props?.meta?.hostname : '') + '/favoriten/', {
          artikel: this.props.productId
        });
        this.setState({favoriten: p.data});
        this?.props?.changeLoading(false);
      }
      if (!this.state.showFavModal) {
        document.body.style.overflowY = 'auto';
      }
      this.setState({showFavModal: !this.state.showFavModal});
    };

    this.changeList = async () => {
      const fav = Array.isArray(this.state.favoriten) ? this.state.favoriten : [];
      if (this.state?.favoriten_neumenge && this.state?.favoriten_bez) {
        const favorit = {};
        favorit.id = 0;
        favorit.menge = this.state?.favoriten_neumenge;
        favorit.bezeichnung = this.state?.favoriten_bez;
        fav.push(favorit);
      }
      const f = await axios.post((this.props?.meta?.conf?.cssCompletePath ? this.props?.meta?.hostname : '') + '/change/ordersaetze/', {
        favoriten: fav,
        artikel: this.props?.productId
      });
      this.setState({
        favoriten: f?.data,
        favoriten_neumenge: 1,
        favoriten_bez: '',
        showFavModal: false
      });
      toast('Die Änderungen wurden erfolgreich gespeichert!');
    };
    this.closeBestellartikelPopup = () => {
      this.setState({bestellartikelPopup: false});
      document.body.style.overflowY = 'auto';
    };
    this.closeUmkartonPopup = () => {
      this.setState({umkartonPopup: false});
      document.body.style.overflowY = 'auto';
    };
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    if (nextProps.menge && this.state.menge !== nextProps.menge) {
      let changeCallback = () => null;
      if (this.props.changeCallback && typeof this.props.changeCallback === 'function') {
        changeCallback = () => this.props.changeCallback(this.state.menge, this.props?.lfdnr);
      }
      this.setState({menge: nextProps.menge}, changeCallback);
    }
  }

  render () {

    const mobile = this.props.mobile || false;
    const medium = this.props.medium || false;
    const mobileBig = this.props.mobileBig || false;
    const product = this.props.product;
    let buttonText = mobile ? <i
      className="icon fas fa-shopping-cart"/> : this.props.cart ? 'bestellt' : (this.props?.hausmesse ? 'Messe-Order' : 'bestellen');

    const inputClasses = [];
    const buttonClasses = [];
    const anbruchClasses = ['anbruch-button', 'icon', 'fas', 'fa-cut'];
    const meta = this.props.meta || {};
    const conf = meta.conf || {};
    let tabindex = null;
    let changeCallback = () => null;
    let anbruchButton = null;
    // const cart = this.props?.cart || false;
    const cartMobile = this.props?.cartMobile || false;

    const anbruch = meta?.licenseCache?.anbruch && !!this.props.anbruch;
    const minMax = meta?.licenseCache?.minMaxMenge || false;
    const gebinde = meta?.licenseCache?.kommissionGebinde || false;
    const hideIcons = this.props?.hideIcons || false;
    const listId = this.props?.listId || false;
    if (this.props.cart) {
      if (!mobile || !cartMobile) {
        inputClasses.push('in-cart');
      }
      buttonClasses.push('in-cart');
    }
    if (this.state.changed) {
      if (this.props.cart) {
        inputClasses.push('changed');
        buttonClasses.push('changed');
        if (!mobile) {
          buttonText = 'aktualisieren';
        } else {
          buttonText = <i className="icon fas fa-sync-alt"/>;
        }
      }
    }
    if (this.props.refresh && !(cartMobile)) {
      inputClasses.push('refresh');
      buttonClasses.push('refresh');
      anbruchClasses.push('refresh');
      buttonText = <i className="icon fas fa-sync-alt"/>;
      tabindex = '-1';
    }
    if (this.props.ordersatzSpezialansicht) {
      inputClasses.push('ordersatz-spezial');
    }

    if (this.props.changeCallback && typeof this.props.changeCallback === 'function') {
      if (this?.props?.mcboerse) {
        changeCallback = () => this.props.changeCallback(this.state.menge, this.props.pos);
      } else {
        changeCallback = () => this.props.changeCallback(this.state.menge);
      }
    }
    let favmodal = null;
    const backdrop = null;

    if (this.state.showFavModal) {
      const onchangeNewList = (e) => {
        if (e.target.value) {
          if (e.target.name === 'neu_menge') {
            this.setState({favoriten_neumenge: e.target.value});
          } else if (e.target.name === 'neu_bezeichnung') {
            this.setState({favoriten_bez: e.target.value});
          }
        }
      };
      const onchange = (e) => {
        const f = this.state.favoriten;
        const value = parseInt(e.target.value);
        const id = parseInt(e.target.name);
        f.forEach((element, index) => {
          if (element.id === id) {
            f[index].menge = value;
          }
        });
        this.setState({favoriten: f});
      };

      let ordersatz = null;
      let ordersatzInfo = null;
      if (product?.ordersatz) {
        if (product.ordersatz.liefermenge1) {
          ordersatzInfo = 'Letzte Bestellmengen: ' + product.ordersatz.liefermenge1;
        }
        if (product.ordersatz.liefermenge2) {
          ordersatzInfo += ', ' + product.ordersatz.liefermenge2;
        }
        if (product.ordersatz.liefermenge3) {
          ordersatzInfo += ', ' + product.ordersatz.liefermenge3;
        }
        if (product.ordersatz.liefermenge4) {
          ordersatzInfo += ', ' + product.ordersatz.liefermenge4;
        }
        if (product.ordersatz.liefermenge5) {
          ordersatzInfo += ', ' + product.ordersatz.liefermenge5;
        }
        ordersatz = <div key={'autoOrder'} className="ordersatzInfo">
          <input type="number" value={product.ordersatz.durchschnittsmenge} readOnly
                 title="Durchschnittliche Bestellmenge Ihrer letzten fünf Bestellungen dieses Artikels."/>
          <span className="bezeichnung">
            Automatischer Ordersatz
          </span>
        </div>;
      }

      favmodal = <Modal className="favModal" onClickBackdrop={() => this.showFavModal()}>
        <Header>
          <h5 className="header">Hinzufügen zum Ordersatz</h5>
          <i className="icon fas fa-times" onClick={this.showFavModal}/>
        </Header>
        <Body>
          {ordersatz}
          {ordersatzInfo ? <span className="info">{ordersatzInfo}</span> : null}
          {
            this.state.favoriten.length
              ? this.state.favoriten.map((favorit) => {
                return <div key={favorit.id} className="oldList">
                  <input className="favMenge" type="number" step="1" min="0" max="999" name={favorit.id}
                         defaultValue={favorit.menge || 0} onChange={onchange}/>
                  <span className="favBezeichnung">{favorit.bezeichnung}</span>
                </div>;
              }) : null
          }
          <div className="newList">
            <input type="number" step="1" min="0" max="999" pattern="[0-9]*" name="neu_menge"
                   value={this.state.favoriten_neumenge}
                   onChange={onchangeNewList}/>
            <input type="text" placeholder="Neue Liste..." className="neu" name="neu_bezeichnung"
                   value={this.state.favoriten_bez}
                   onChange={onchangeNewList}/>
          </div>
        </Body>
        <Footer>
          <button className="saveButton" onClick={this.changeList}>Änderungen speichern</button>
        </Footer>
      </Modal>;
    }

    if (anbruch) {
      inputClasses.push('anbruch');
      anbruchButton =
        <i onClick={this.showAnbruchModal} className={anbruchClasses.join(' ')}
           title="Bei diesem Produkt sind Anbruchmengen gestattet!"/>;
      buttonClasses.push('anbruch');
    }

    let anbruchModal = null;
    if (anbruch && this.state.anbruchModal) {
      let vkEinheit = <div>
        <span>{this.props.verkaufseinheit}</span><input value={this.state.menge_vk} ref={this.vk_ref}
                                                        min={0} max={999} step={1}
                                                        onFocus={(e) => {
                                                          e.target.select();
                                                        }}
                                                        onChange={(e) => {
                                                          let menge_vk = e.target.value || 0;
                                                          if (!/^[0-9]{1,3}$/.test(menge_vk)) {
                                                            menge_vk = this.state.menge_vk;
                                                          }
                                                          this.setState({menge_vk});
                                                        }}
                                                        type="number"/>
      </div>;
      let basisEinheit = <div>
        <span>{this.props.basiseinheit}</span><input value={this.state.menge_basis}

                                                     onFocus={(e) => {
                                                       e.target.select();
                                                     }}
                                                     min={0} max={99} step={1}
                                                     onChange={(e) => {
                                                       let menge_basis = e.target.value || 0;
                                                       if (!/^[0-9]{1,2}$/.test(menge_basis)) {
                                                         menge_basis = this.state.menge_basis;
                                                       }
                                                       this.setState({menge_basis});
                                                     }}
                                                     type="number"/></div>;
      anbruchModal = <div className="anbruch-modal" ref={this.anbruchmodal_ref}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              this.saveAnbruch();
                            } else if (e.key === 'Escape') {
                              this.hideAnbruchModal();
                            }
                          }}>
        <button className="close" onClick={this.hideAnbruchModal}>&times;</button>
        <h3>Anbruch-Assistent</h3>
        {vkEinheit}
        {basisEinheit}
        <button className="cancel" onClick={this.hideAnbruchModal}>schliessen</button>
        <button className="save" onClick={this.saveAnbruch}>übernehmen</button>
      </div>;

      if (mobile) {
        anbruchModal = <Modal className="anbruch-modal" ref={this.anbruchmodal_ref}
                              onClickBackdrop={() => this.hideAnbruchModal()}
        >
          <Header>
            <h3>Anbruch-Assistent</h3>
          </Header>
          <Body>
            {vkEinheit}
            {basisEinheit}
          </Body>
          <Footer>
            <button className="cancel" onClick={this.hideAnbruchModal}>schliessen</button>
            <button className="save" onClick={this.saveAnbruch}>übernehmen</button>
          </Footer>
        </Modal>;
      }
    }
    if (this.props?.dontShow) {
      return <div className="_ProductInput inactive"><span>&nbsp;</span></div>;
    } else if (this.props.inactive) {

      let textHinweis = null;
      if (this.props.fakturiertext) {
        textHinweis = <i className="icon fas fa-info-circle" title={this.props.fakturiertext}/>;
      }
      return <div className="_ProductInput inactive"><span>zzt. nicht lieferbar</span>{textHinweis}</div>;
    } else {
      let onChange = (e) => {
        let menge;
        try {
          menge = parseInt(e.target.value, 10);
        } catch (e) {
          menge = this.state.menge;
        }
        if (menge == null || Number.isNaN(menge) || menge < 0 || menge > 999) {
          menge = this.state.menge;
        }
        if (gebinde && this.props.nur_gebinde && this.props.picmengeverkauf === 1 && (menge % this.props.umpack)) {
          if (menge - this.state.menge === 1) { // Einer mehr
            menge = menge + (this.props?.umpack - (menge % this.props?.umpack));
          } else if (menge - this.state.menge === -1) {
            menge = menge - (menge % this.props?.umpack);
          }
        }
        if (menge != this.state.menge) {
          this.setState({
            menge,
            changed: true
          }, changeCallback);
        }
      };
      if (anbruch) {
        onChange = (e) => {
          let menge;
          try {
            menge = parseFloat(e.target.value);
            if (menge != null && !Number.isNaN(menge)) {
              menge = menge.toFixed(2);
            }
          } catch (e) {
            menge = this.state.menge;
          }
          if (menge == null || Number.isNaN(menge) || menge < 0 || menge > 999) {
            menge = this.state.menge;
          }
          if (menge != this.state.menge) {
            const res = parseMengeToAnbruch(menge);
            const vk = res?.vk || 0;
            const basis = res?.basis || 0;
            this.setState({
              menge,
              changed: true,
              menge_vk: vk,
              menge_basis: basis
            }, changeCallback);
          }
        };
      }
      let onBlur = null;

      if (mobile) {
        onBlur = () => {
          this.setState({changed: !this.props.changeCart(this.state.menge, minMax, gebinde, this?.props?.erlaubteDistMenge, (this.props?.meta?.conf?.cssCompletePath ? this.props?.meta?.hostname : ''))});
        };
      }
      const addOne = () => {
        let menge = this.state.menge;
        if (this.state.menge < 999 && !this?.props?.readonly) {
          if (gebinde && this.props?.nur_gebinde && this.props?.picmengeverkauf === 1) {
            // Gebinde auffüllen
            if (menge % this.props?.umpack) {
              menge = menge + (this.props?.umpack - (menge % this.props?.umpack));
            } else {
              menge += this.props.umpack;
            }
          } else if (anbruch) {
            let vk = this.state.menge_vk || 0;
            const basis = this.state.menge_basis || 0;
            vk += 1;
            menge = `${vk}.${basis.toString().padStart(2, '0')}`;
            this.setState({
              menge,
              menge_vk: vk,
              menge_basis: basis
            });
          } else {
            menge += 1;
          }
          if (cartMobile) {
            this.setState({
              changed: !this.props.changeCart(menge, minMax, gebinde, this?.props?.erlaubteDistMenge, (this.props?.meta?.conf?.cssCompletePath ? this.props?.meta?.hostname : '')),
              menge: this.state.menge
            });
          } else {
            this.setState({
              changed: true,
              menge: menge
            }, changeCallback);
          }
        }
      };

      const subtractOne = () => {
        let menge = this.state.menge;
        //Ich glaube hier

        if (this.state.menge > 1 || (this.props?.mcboerse && this.state.menge > 0) && !this?.props?.readonly) {
          if (gebinde && this.props?.nur_gebinde && this.props?.picmengeverkauf === 1) {
            // Gebinde auffüllen
            if (menge % this.props?.umpack) {
              menge = menge - (menge % this.props?.umpack);
            } else if (anbruch) {
              let vk = this.state.menge_vk || 0;
              const basis = this.state.menge_basis || 0;
              vk -= 1;
              menge = `${vk}.${basis.toString().padStart(2, '0')}`;
              this.setState({
                menge,
                menge_vk: vk,
                menge_basis: basis
              });
            } else {
              menge -= this.props.umpack;
            }
          } else {
            menge -= 1;
          }
          if (cartMobile) {
            this.setState({
                changed: !this.props.changeCart(menge, minMax, gebinde, this?.props?.erlaubteDistMenge, (this.props?.meta?.conf?.cssCompletePath ? this.props?.meta?.hostname : '')),
                menge: this.state.menge
              }
            );
          } else {
            this.setState({
              changed: true,
              menge: menge
            }, changeCallback);
          }
        }
      };

      let iconOne = medium && listId && !(this.props?.ordersatzSpezialansicht) ? <i className="icon fas fa-plus"
                                                                                    onClick={addOne}/> : <i
        className="icon fas fa-minus" onClick={subtractOne}/>;
      let iconTwo = medium && listId && !(this.props?.ordersatzSpezialansicht) ? <i className="icon fas fa-minus"
                                                                                    onClick={subtractOne}/> : <i
        className="icon fas fa-plus" onClick={addOne}/>;

      let gridClass = '5fr';

      //hier
      if (anbruch) {
        if (listId || cartMobile) {
          gridClass = 'fr4 anbruch';
        } else if (!meta?.login) {
          gridClass = 'fr5 anbruch';
        } else {
          gridClass = 'fr6 anbruch';
        }
      } else {
        if (listId || cartMobile) {
          gridClass = 'fr3';
        } else if (!meta?.login) {
          gridClass = 'fr4';
        } else {
          gridClass = 'fr5';
        }
      }

      let bestellartikelPopup = null;

      if (this.state.bestellartikelPopup) {
        bestellartikelPopup =
          <Modal className="bestellartikelpopup" onClickBackdrop={this.closeBestellartikelPopup}>
            <Header>
              <h5 className="header">Bestellartikel</h5>
              <i className="icon fas fa-times" onClick={this.closeBestellartikelPopup}/>
            </Header>
            <Body>
              <P1> {this.state.bestellartikelpopuptext
                ? this.state.bestellartikelpopuptext
                : 'Möchten Sie den Bestellartikel "' + this.props?.productId + '" wirklich dem Warenkorb hinzufügen?'}</P1>
            </Body>
            <Footer>
              <button className="cancel" onClick={this.closeBestellartikelPopup}>Abbrechen</button>
              <button className="saveButton" onClick={() => {
                if (this.state.bestellartikelPopupButtonText == 'Hinzufügen') {
                  this.setState({
                    changed: !this.props.changeCart(this.state.menge, minMax, gebinde, this?.props?.erlaubteDistMenge, (this.props?.meta?.conf?.cssCompletePath ? this.props?.meta?.hostname : ''))
                  }, () => this.closeBestellartikelPopup());
                } else {
                  this.closeBestellartikelPopup();
                }
              }}>{this.state.bestellartikelPopupButtonText}
              </button>
            </Footer>
          </Modal>;
      }

      let umkarton = null;

      if (this.props?.rabatt_fuer_umkarton && this?.umkartonNew && this.state?.umkartonPopup && meta?.licenseCache?.umkarton) {
        umkarton =
          <Modal className="umkartonpopup" onClickBackdrop={this.closeUmkartonPopup}>
            <Header>
              <h5 className="header">Originalkarton Vergünstigung</h5>
              <i className="icon fas fa-times" onClick={this.closeUmkartonPopup}/>
            </Header>
            <Body>
              <P1>Bei diesem Artikel gewähren wir eine Vergünstigung
                von {venditshop.helper.formatCurrency(this.props?.rabatt_fuer_umkarton)} pro Verkaufseinheit bei
                Bestellungen von Originalkartons (Menge: {this?.props?.umkartonmenge})
              </P1>
            </Body>
            <Footer>
              <button className="cancel" onClick={() => this.closeUmkartonPopup()}>Abbrechen</button>
              <button className="saveButton" onClick={() => {
                this.setState({
                  changed: !this.props.changeCart(this.state.menge, minMax, gebinde, this?.props?.erlaubteDistMenge, (this.props?.meta?.conf?.cssCompletePath ? this.props?.meta?.hostname : ''))
                }, () => this.closeUmkartonPopup());
              }}>Hinzufügen
              </button>
            </Footer>
          </Modal>;
      }
      const checkBestellartikel = async (artikel) => {
        const result = await axios.post((this.props?.meta?.conf?.cssCompletePath ? this.props?.meta?.hostname : '') + '/checkbestellartikel/', {artikel: artikel});
        return result;
      };
      let classes = [];
      if (this.props?.dontShowButton) {
        classes.push('noButton');
      }

      //Alle Methoden entsprechend anpassen
      //Anbruch hat tmu nicht

      if (this.props?.hausmesse && !this?.props?.naturalrabatt) {
        let onChange = (kw, e) => {
          let menge;
          try {
            menge = parseInt(e.target.value, 10);
          } catch (e) {
            menge = this.state.hausmesseMengen[kw] || 0;
          }
          if (menge == null || Number.isNaN(menge) || menge < 0 || menge > 999) {
            menge = this.state.hausmesseMengen[kw] || 0;
          }
          // gebinde input
          // if (gebinde && this.props.nur_gebinde && this.props.picmengeverkauf === 1 && (menge % this.props.umpack)) {
          //   if (menge - this.state.menge === 1) { // Einer mehr
          //     menge = menge + (this.props?.umpack - (menge % this.props?.umpack));
          //   } else if (menge - this.state.menge === -1) {
          //     menge = menge - (menge % this.props?.umpack);
          //   }
          // }
          if (menge != (this.state.hausmesseMengen[kw] || 0)) {
            // this.setState({menge, changed: true}, changeCallback);
            let arr = this.state.hausmesseMengen || {};
            arr[kw] = menge;
            this.setState({
              hausmesseMengen: arr,
              changed: true
            });
            if (this?.props?.changeCallbackMesse) {
              this?.props?.changeCallbackMesse(this.state.hausmesseMengen, this.props.pos);
            }
            this.forceUpdate();
          }
        };

        let inputs = [];

        inputs = this.props?.liefertage?.map((pos) => {

          let minusOne = () => {
            onChange(pos.kw, {
              target: {
                value: this?.state?.hausmesseMengen[pos.kw] > 0 ?
                  (this.state.hausmesseMengen[pos.kw] - 1) : 0
              }
            });
            if (cartMobile) {
              this.setState({changed: !this.props.changeMesseCart(this.state.hausmesseMengen)});
            }
          }

          let addOne = () => {
            onChange(pos.kw, ({target: {value: (this.state.hausmesseMengen[pos.kw] || 0) + 1}}));
            if (cartMobile) {
              this.setState({changed: !this.props.changeMesseCart(this.state.hausmesseMengen)});
            }
          }

          const iconOne = medium ? <i className="icon fas fa-plus" onClick={addOne}/> : <i
            className="icon fas fa-plus" onClick={addOne}/>;
          const iconTwo = medium ? <i className="icon fas fa-minus" onClick={minusOne}/> : <i
            className="icon fas fa-minus" onClick={minusOne}/>;

          //
          // console.log(this.state.hausmesseMengen);
          // console.log(this.state.hausmesseMengen[pos.kw]);

          return <div className={'inputDiv'}>
            <P3>KW {pos.kw}</P3>
            <div
              className={'_ProductInput ' + gridClass + ' ' + classes.join(' ')}>
              {mobile && !hideIcons ? iconTwo : null}
              <input type={mobile || medium || mobileBig || anbruch ? 'text' : 'number'}
                // onKeyDown={this.handleKeyDownMenge}
                     pattern={'[0-9]*'}
                     inputMode={'decimal'}
                     min={0}
                     max={999}
                     step={1}
                     className={inputClasses.join(' ')}
                     onChange={(e) => onChange(pos.kw, e)}
                     style={anbruch ? {opacity: 1} : {}}
                     readOnly={anbruch || this.props?.readonly} // false /* anbruch */}
                     value={anbruch
                       ? parseFloat(this.state.hausmesseMengen[pos.kw] || 0).toFixed(2).replace('.', ',')
                       : this.state.hausmesseMengen[pos.kw] || 0}
              />
              {mobile && !hideIcons ? iconOne : null}
            </div>
          </div>;

        });

        return <div className={'hausmesseProductInputs'}>
          {inputs}
          {!this.props?.dontShowButton ? <button tabIndex={tabindex}
                                                 className={buttonClasses.join(' ')}
                                                 disabled={!Object.keys(this.state.hausmesseMengen).length}
                                                 onClick={async () => {
                                                   this.setState({changed: !this.props.changeMesseCart(this.state.hausmesseMengen)});
                                                 }
                                                 }
          >
            {buttonText}
          </button> : null}
        </div>;
      }

      if (this?.props?.naturalrabatt && this?.props?.hausmesse) {
        onChange = (e) => {
          let menge;
          try {
            menge = parseInt(e.target.value, 10);
          } catch (e) {
            menge = this.state.menge;
          }
          if (menge == null || Number.isNaN(menge) || menge < 0 || menge > 999) {
            menge = this.state.menge;
          }
          // // gebinde input
          // if (gebinde && this.props.nur_gebinde && this.props.picmengeverkauf === 1 && (menge % this.props.umpack)) {
          //   if (menge - this.state.menge === 1) { // Einer mehr
          //     menge = menge + (this.props?.umpack - (menge % this.props?.umpack));
          //   } else if (menge - this.state.menge === -1) {
          //     menge = menge - (menge % this.props?.umpack);
          //   }
          // }

          if (menge != this.state.menge) {
            this.setState({
              menge,
              changed: true
            }, () => this?.props?.changeCallbackMesse({'0': this.state.menge}, this.props.pos));
          }
        }

        let tmp1 = {target: {value: this.state.menge > 0 ? this.state.menge - 1 : 0}};

        iconOne = medium && listId && !(this.props?.ordersatzSpezialansicht) ? <i className="icon fas fa-plus"
                                                                                  onClick={() => onChange(tmp1)}/> : <i
          className="icon fas fa-minus" onClick={() => onChange(tmp1)}/>;
        let tmp2 = {target: {value: this.state.menge + 1}};

        iconTwo = medium && listId && !(this.props?.ordersatzSpezialansicht) ? <i className="icon fas fa-minus"
                                                                                  onClick={() => onChange(tmp2)}/> : <i
          className="icon fas fa-plus" onClick={() => onChange(tmp2)}/>;
      }

      let styles = null;
      if (meta?.licenseCache?.artikelhervorheben && this.props?.hervorheben) {
        if (this.props?.background_color_hex) {
          classes.push('hervorheben');
          styles = {
            color: (this.props?.font_color == 1 ? 'white' : 'black'),
            border: '1px solid ' + (this.props?.font_color == 1 ? 'white' : 'black'),
            backgroundColor: this.props?.background_color_hex
          };
        }
      }

      return <div
        className={'_ProductInput ' + gridClass + ' ' + classes.join(' ')}>

        {mobile && !hideIcons ? iconOne : null}

        <input type={mobile || medium || mobileBig || anbruch ? 'text' : 'number'}
               onKeyDown={this.handleKeyDownMenge} onFocus={(e) => {
          if (anbruch) {
            this.showAnbruchModal();
          } else {
            e.target.select();
          }
        }}
               pattern={'[0-9]*'}
               inputMode={'decimal'}
               min={0}
               max={999}
               step={1}
               className={inputClasses.join(' ')}
               onChange={onChange}
               autoComplete="off"
               style={anbruch ? {opacity: 1} : {}}
               readOnly={anbruch || this.props?.readonly} // false /* anbruch */}
               value={anbruch ? parseFloat(this.state.menge).toFixed(2).replace('.', ',') : this.state.menge}
        />

        {mobile && !hideIcons ? iconTwo : null}
        {anbruchButton}
        {(!listId || this.props.ordersatzSpezialansicht) ||
        !mobile ? ((anbruch && this.props.refresh) || (cartMobile) || this.props?.dontShowButton
          ? null
          : <button tabIndex={tabindex} style={styles}
                    className={buttonClasses.join(' ')}
                    onClick={async () => {
                      if (this.state.menge >= 0) {
                        let checkBestellartikel2 = false;
                        if (this.props.bestellartikel && conf?.bestellartikelcheck) {
                          checkBestellartikel2 = await checkBestellartikel(this.props?.productId);
                        }

                        if (conf?.minBestellartikel && this.props.bestellartikel &&
                          this.state.menge != 0 &&
                          (this.props.minbestellmenge > this.state.menge ||
                            this.state.menge % this.props.minbestellmenge != 0) && this.props.minbestellmenge) {
                          this.setState({
                            bestellartikelPopup: true,
                            bestellartikelpopuptext: 'Der Bestellartikel ' + this.props?.productId + ' hat eine Mindestbestellmenge von ' + this.props.minbestellmenge + '. ' +
                              'Es dürfen nur Mengen dem Warenkorb hinzugefügt werden, die durch ' + this.props.minbestellmenge + ' teilbar sind.',
                            bestellartikelPopupButtonText: 'OK'
                          });
                        } else if (checkBestellartikel2?.data && this.state.menge != 0) {
                          this.setState({
                            bestellartikelPopup: true,
                            bestellartikelpopuptext: 'Der Bestellartikel ' + this.props?.productId + ' ist bereits in einem ' +
                              'noch offenen Vorablieferschein enthalten. Möchten Sie den Bestellartikel dem Warenkorb wirklich hinzufügen?'
                          });
                        } else if (this.props.bestellartikel && this.props.meta?.licenseCache?.bestellartikelPopup && !this.props.cart && this.state.menge != 0) {
                          this.setState({
                            bestellartikelPopup: true,
                            bestellartikelpopuptext: ''
                          });
                        } else if (this?.props?.rabatt_fuer_umkarton && this?.props?.umkartonmenge && this?.props?.umkartonNew && !this.props.cart && meta?.licenseCache?.umkarton) {
                          this.setState({umkartonPopup: true});
                        } else {
                          this.setState({changed: !this.props.changeCart(this.state.menge, minMax, gebinde, this?.props?.erlaubteDistMenge, (this.props?.meta?.conf?.cssCompletePath ? this.props?.meta?.hostname : ''))});
                        }
                      }
                    }}
          >
            {buttonText}
          </button>) : null}

        {!listId && mobile && (mobile && !cartMobile) && meta?.login && !this.props?.dontShowButton ? <button
          className="addToOrdersatz" disabled={this.props.productType === 'b'}
          onClick={this.showFavModal}><i
          className="icon fas fa-list"/>
        </button> : null}
        {anbruchModal}
        {favmodal}
        {backdrop}
        {bestellartikelPopup}
        {umkarton}
      </div>;
    }
  }
}

export default ReactRedux.connect((state, ownProps) => {
  if (ownProps?.hausmesse) {
    if (ownProps?.mcboerse) {
      let cart = false;
      let mengen = {};

      let natrualrabatt = ownProps?.pos?.naturalrabatt;

      if (!(natrualrabatt == 0 || natrualrabatt == 1)) {
        natrualrabatt = ownProps?.naturalrabatt;
      }

      if (state.messecart['m'] && state.messecart['m'][ownProps?.mcboerse] && state.messecart['m'][ownProps?.mcboerse]['mengen']
        && (natrualrabatt == 0 || natrualrabatt == 1)
        && state.messecart['m'][ownProps?.mcboerse]['mengen'][ownProps.productId + '-' + natrualrabatt]) {
        mengen = state.messecart['m'][ownProps?.mcboerse]['mengen'][ownProps.productId + '-' + natrualrabatt];
      }

      return {
        cart,
        hausmessemengen: mengen,
        meta: state.meta,
        mobile: state.mobile.isMobile,
        medium: state.mobileMedium.isMedium,
        mobileBig: state.mobileBig.isBig,
        updateAmount: state.updateAmount
      };

    } else {
      let cart = false;
      let mengen = {};
      if (state.messecart[ownProps.productType] && state.messecart[ownProps.productType][ownProps.productId]) {
        mengen = state.messecart[ownProps.productType][ownProps.productId].mengen;
        cart = true;
      }

      return {
        cart,
        hausmessemengen: mengen,
        meta: state.meta,
        mobile: state.mobile.isMobile,
        medium: state.mobileMedium.isMedium,
        mobileBig: state.mobileBig.isBig,
        updateAmount: state.updateAmount
      };
    }

  } else {

    let defaultMenge = 1;
    if (ownProps.defaultMengeNull) {
      defaultMenge = 0;
    }

    let menge = ownProps.menge || defaultMenge;
    let cart = false;
    if (state.cart[ownProps.productType] && state.cart[ownProps.productType][ownProps.productId]) {
      menge = state.cart[ownProps.productType][ownProps.productId].menge;
      cart = true;
    }

    if (!ownProps?.listId) {
      return {
        cart,
        meta: state.meta,
        mobile: state.mobile.isMobile,
        medium: state.mobileMedium.isMedium,
        mobileBig: state.mobileBig.isBig,
        updateAmount: state.updateAmount
      };
    } else {
      return {
        menge,
        cart,
        meta: state.meta,
        mobile: state.mobile.isMobile,
        medium: state.mobileMedium.isMedium,
        mobileBig: state.mobileBig.isBig,
        updateAmount: state.updateAmount
      };
    }
  }
}, (dispatch, ownProps) => ({
  changeLoading: (loading) => {
    dispatch(receiveLoadingUpdate(loading));
  },
  changeMesseCart: (mengen) => {
    //Json mengen kw: menge
    dispatch(updateMesseCart(ownProps.hausmesse, ownProps.productType, ownProps.productId, mengen));
    return mengen;
  },
  changeCart: (menge, minMax, gebinde, erlaubtedistributionsmenge, url) => {
    if (erlaubtedistributionsmenge && erlaubtedistributionsmenge <= 0) {
      dispatch(setMSG('Ihre erlaubte Bestellmenge dieser Börse wurde überschritten'));
      dispatch(setUpdateMSG(true));
      return false;
    } else if (erlaubtedistributionsmenge && erlaubtedistributionsmenge - menge < 0) {
      dispatch(setMSG('Ihre erlaubte Bestellmenge dieser Börse wurde überschritten. Die Menge wurde entsprechend angepasst.'));
      dispatch(setUpdateMSG(true));
      menge = erlaubtedistributionsmenge;
    }

    if (ownProps?.untergrenze && ownProps?.untergrenze > menge && menge != 0 && minMax) {
      // Fehlermeldung untergrenze
      dispatch(setMSG('Die bestellte Menge entspricht nicht der Mindestbestellmenge (' + ownProps?.untergrenze + ') des Artikels! '));
      dispatch(setUpdateMSG(true));
      return false;
    }
    if (ownProps?.obergrenze && ownProps?.obergrenze < menge && minMax) {
      // Fehlermeldung obergrenze
      menge = ownProps?.obergrenze;
      dispatch(setMSG('Die bestellte Menge überschreitet die maximale Bestellmenge des Artikels. Die Menge wurde auf die maximale ' +
        'Bestellmenge zurückgesetzt.'));
      dispatch(setUpdateMSG(true));
    }
    if (gebinde && (menge % ownProps?.umpack) && ownProps?.nur_gebinde && ownProps?.picmengeverkauf === 1) {
      // Gebinde auffüllen
      menge = menge + (ownProps?.umpack - (menge % ownProps?.umpack));

    }

    dispatch(updateShoppingCart(ownProps.productType, ownProps.productId, menge, true, null, null, url,
      !!ownProps?.vertriebsaktion));

    if ((ownProps.menge === ownProps?.obergrenze && menge >= ownProps?.obergrenze && minMax) || (ownProps.menge === menge)) {
      dispatch(setUpdateAmount());
    }
    if (Cookies.get('SliderClick') === 'true') {
      _paq.push(['trackEvent', 'Slider', 'Kauf', 'Slider Kauf']);
    }
    if (Cookies.get('ExklusivAngeboteClick') === 'true') {
      _paq.push(['trackEvent', 'Webshop Exklusiv-Angebote', 'Kauf', 'Webshop Exklusiv-Angebote Kauf']);
    }
    return menge;
  }
}), null, {forwardRef: true})(ProductInput);
